import { syncAuthCookies } from '@monolith/helpers/auth-cookies';

import { shouldUseCredentialedGraphQL } from './helpers/credentialedGraphql';
import { getIdToken, getRefreshToken } from './cookie-auth';

const LOGIN_REFRESH_MUTATION = `
    mutation loginRefresh($refreshToken: String!) {
        loginRefresh(refreshToken: $refreshToken) {
            status
            error
            idToken
        }
    }
`;

export const refreshIdToken = async (refreshToken) => {
    const fetchOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            operationName: 'loginRefresh',
            query: LOGIN_REFRESH_MUTATION,
            variables: { refreshToken },
        }),
    };

    if (shouldUseCredentialedGraphQL()) {
        fetchOptions.credentials = 'include';
    }

    const response = await fetch(__GRAPHQL_API__, fetchOptions);

    const result = await response.json();
    const refreshResult = result?.data?.loginRefresh;

    if (refreshResult?.status !== 'ok') {
        throw new Error(refreshResult?.error || 'Token refresh failed');
    }

    if (refreshResult?.idToken) {
        syncAuthCookies(refreshResult.idToken, getRefreshToken());
        return refreshResult.idToken;
    }

    return getIdToken();
};
